import itemsJur from '@/nav/items-jur'
import itemsMain from '@/nav/items-main'
import itemsBottom from '@/nav/items-bottom'

let _items = [];

Array.prototype.push.apply(_items, itemsMain.items);
Array.prototype.push.apply(_items, itemsJur.items);
Array.prototype.push.apply(_items, itemsBottom.items);

export default {
    items: _items
}
